module.exports = __webpack_public_path__ + "img/tomato-logo.669a42e4.png";